export default __webpack_public_path__ + "static/media/3.2626927d.png";